const weekAgo = () => new Date().getTime() - 1000 * 60 * 60 * 24 * 7;
const minuteAgo = () => new Date().getTime() - 1000 * 60;
export const isLessThanMinute = (time) => new Date(time).getTime() > minuteAgo();
const isLessThanWeek = (time) => new Date(time).getTime() > weekAgo();
const isNotCurrentYear = (time) => new Date().getYear() !== new Date(time).getYear();
export const getTimeAgoFormat = (time) => {
    if (isLessThanWeek(time)) {
        return 'timeRelative';
    }
    if (isNotCurrentYear(time)) {
        return 'fullDate';
    }
    return 'date';
};
//# sourceMappingURL=time-ago.js.map